var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.189,
    height: 67.318,
    viewBox: "0 0 70.189 67.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.132,
    x2: 0.947,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 70.189,
    height: 67.318,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M53.206,67.318a5.7,5.7,0,0,1-2.691-.67L35.164,58.574l-15.5,8.074a5.776,5.776,0,0,1-8.377-6.1l2.923-17.08L1.752,31.218a5.774,5.774,0,0,1,3.2-9.856l17.151-2.5L29.912,3.23a5.775,5.775,0,0,1,10.369,0l7.674,15.542,17.271,2.59a5.772,5.772,0,0,1,3.215,9.856L56.028,43.309,58.907,60.55a5.807,5.807,0,0,1-5.7,6.768M5.671,27.194,18.069,39.3a5.727,5.727,0,0,1,1.666,5.1L16.811,61.5l1.55,2.661-1.3-2.485L32.4,53.6a5.842,5.842,0,0,1,5.383,0l15.336,8.07.251-.176L50.429,44.421A5.811,5.811,0,0,1,52.094,39.3L64.507,27.194l-.086-.292L47.269,24.417a5.8,5.8,0,0,1-4.357-3.17L35.235,5.7c-.015-.041-.045-.086-.146-.086L27.266,21.246a5.8,5.8,0,0,1-4.357,3.17L5.757,26.9,3.695,29.2Z",
    transform: "translate(0 -0.002)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon5);
export default __webpack_public_path__ + "static/media/social_icon5.86a79fcb019a06ba3abe63d6dfe5ed97.svg";
export { ForwardRef as ReactComponent };